import { Component, EventEmitter, Input, OnInit,NgZone } from '@angular/core';
import { ICreditCardSummaryData } from 'src/app/common/models/credit-card.model';
import { DebitCardDetail } from 'src/app/models/Debit-card-details.model';
import { AccountDetails } from 'src/app/models/account-info.model';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';
import { ServiceStock } from '../../service-stock.service';
import { PopupComponent } from 'src/app/common/components/popup/popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { MobileService } from 'src/app/mobile.services';
import { Data } from "src/app/DataService";
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";
import { DeviceDetectorService } from 'ngx-device-detector';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { DebitCardsService } from 'src/app/debit-card/services/debit-cards.service';
declare var cordova: any;
declare var entrust: any;
declare var $: any;

@Component({
  selector: 'debit-card-tab-container',
  templateUrl: './debit-card-tab-container.component.html',
  styleUrls: ['./debit-card-tab-container.component.scss']
})
export class DebitCardTabContainerComponent implements OnInit {

  @Input() containerData: DebitCardDetail;

  accountInfo: AccountDetails;
  isMobile: boolean = false;
  isCardinWallet: boolean;
  isCardStatusActVal: boolean = false;
  isCardStatusActVal_Default: boolean = false;
  isCardStatusDeactVal: boolean = false;
  isRegistered: boolean = false;
  isRegisterVal: boolean = false;
  isNFCAvailable: boolean = false;
  digitalCardNum: any;
  displayTooltip: boolean;
  tabList: any[] = [
    { id: 'history', text: 'History' },
    { id: 'details', text: 'Details' }
  ]

  constructor(
    private accounts: AccountsService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private services: ServiceStock,
    public dataStore: Data,
    private diagnostic: Diagnostic,
    protected _commonService: CommonService,
    private _nativeStorage: NativeStorageService,
    private dialogRef: MatDialogRef<InfoPopupComponent>, private _dialog: MatDialog,
    private mobileService: MobileService,
    private ngZone: NgZone,
    private _debitService: DebitCardsService
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    let accountNumber = this.containerData.accountNumber;
    this.accountInfo = this.accounts.getList()[0];
   // if(this.containerData.cardCategory.includes("Debit")){ 
      this.nfcCardCheck(this);
  //  } else if (this.containerData.cardCategory.includes("Credit")){
  //   //do nothing
  //  }
  }
 
  nfcCardCheck(that) {
    this.dataStore.connectionVal = localStorage.getItem("walletID");
    if (this.isMobile && this.deviceService.os.toLowerCase() == 'android' && this.dataStore.nfcValid) {
      this._nativeStorage.retriveData('nfcProvisioning').then((value) => {
        var nfcProvision = value;
        if (nfcProvision == "true") {
          if (that.dataStore.connectionVal != "" || that.dataStore.connectionVal != null) {
              that.nfcCardStatus(that.containerData.cardRefNumber);
            // that.nfcCardStatus("mc4211");
          }
          else {//hide Tap button
            console.log("Hiding bt");
          }
        }
        else {
          console.log("Hiding bt");
          //hide Tap button
        }
      }).catch((reason) => {
        console.log(reason);//hide Tap button
      });
    } //if ends
  }

  nfcCardStatus(cardId) {
    var that=this;
    if (this.containerData.status.toLowerCase() == "blocked") {
      this.isRegisterVal = false
      this.isCardStatusActVal = false;
      this.isCardStatusDeactVal = true;
      this.isCardStatusActVal_Default = false;
	  // $('.summary-card-footer').hide();
    }
    else if (this.containerData.status.toLowerCase() == "inactive") {
      this.isRegisterVal = false;
      this.isCardStatusActVal = false;
      this.isCardStatusDeactVal = true;
      this.isCardStatusActVal_Default = false;
	 // $('.summary-card-footer').hide();
    }
    else if (this.containerData.status.toLowerCase() == "active") {
      //SDK call starts
      this._commonService.showSpinner();
     
      entrust.checkCardStatus(cardId, (result: any) => {
        // alert("checkCardStatus Result"+result);
        let response = result;
        localStorage.setItem("isCardDigital","true");
        localStorage.setItem("cardStatus",response.cardStatus);
        localStorage.setItem("isCardinWallet",response.isCardinWallet);
        localStorage.setItem("isCardProvisioned",response.isCardProvisioned);
        that.tapandPayValidation(cardId,response.isCardDigital, response.cardStatus, response.isCardinWallet,response.isCardProvisioned, '');
        that._commonService.hideSpinner();
        // check the status using sdk
      }, (reason: any) => {
        let error = reason;
        // alert("checkCardStatus Error"+error);
        if (error == "Not_Digitized") {
          //  that.tapandPayValidation('', '', '', error);
        //  localStorage.setItem("nfcCardStatusError",error)
        localStorage.setItem("isCardDigital", "false");
          that.isRegisterVal = true;
          that.isCardStatusActVal = false;
          that.isCardStatusDeactVal = false;
          that.isCardStatusActVal_Default = false;
		 // $('.summary-card-footer').hide();
          that._commonService.hideSpinner();
          that._debitService.setUpMenu();
        }
        
      });
      //sdk call ends
    }
  }

  tapandPayValidation(cardId,isCardDigital, cardStatus, isCardinWallet, isCardProvisioned, error) {

    var that = this;
    if (cardStatus != "Active") {
      this.isRegisterVal = false;
      this.isCardStatusActVal = false;
      this.isCardStatusActVal_Default = false;
      this.isCardStatusDeactVal = true;
	 // $('.summary-card-footer').hide();
   this._debitService.setUpMenu();
    }

    else if (cardStatus == "Active" && !isCardinWallet) {
      this.isRegisterVal = true;
      this.isCardStatusActVal = false;
      this.isCardStatusActVal_Default = false;
      this.isCardStatusDeactVal = false;
      this._debitService.setUpMenu();
	//  $('.summary-card-footer').hide();
    }
    else if (isCardDigital && cardStatus == "Active" && isCardinWallet) {
      if (isCardProvisioned) {
      this.isRegisterVal = false;
      this.isCardStatusDeactVal = false;

      this._nativeStorage.retriveData('default')?.then(
        (value) => {
          if(cardId == value.cdId){
            that.isCardStatusActVal_Default = true;
            that.digitalCardNum = value.tkn;
          }else{
            that.isCardStatusActVal = true;
          }
        }
      ).catch(e => {
        that.isCardStatusActVal = true;
        that.isCardStatusActVal_Default = false;
      });
      this._debitService.setUpMenu();
	//  $('.summary-card-footer').show();
      }
      else {
      this.isRegisterVal = false;
      this.isCardStatusActVal = false;
      this.isCardStatusActVal_Default = false;
      this.isCardStatusDeactVal = true;
      this._debitService.setUpMenu();
	//  $('.summary-card-footer').hide();
      }
      
    }
  }

  nfcInstructions() {
    var cardArray = { "CardRefNO": this.containerData.cardRefNumber, "CardStatus": this.containerData.status, "CardNumber": this.containerData.cardNumber, "CardType": this.containerData.cardType };
    //NFC eligibility check starts
    if (this.isMobile && this.deviceService.os.toLowerCase() == 'android') {
      this.diagnostic.isNFCAvailable()
        .then((isEnabled) => {
          this.isNFCAvailable = isEnabled;
          // alert("isNFCAvailable"+this.isNFCAvailable);
          if(this.isNFCAvailable) {
            //biometric authentication starts
            if (this.mobileService.isDeviceRegistered) {
              this.mobileService.deviceAuth = new EventEmitter();
              this.mobileService.deviceAuth.subscribe(
                (deviceAuth) => {
                  if (deviceAuth) {
                    //TODO: device auth success
                    this.nfcDefaultAppCheck(this.containerData.cardRefNumber);
                   
                //  this.nfcPay("mc4211");
                 //   this.router.navigate(['/home', 'tapnpaynfcinstruction'], { state: { cardData: cardArray } });
                  } else {
                    //TODO: show device auth error
                  }
                }, (err) => {
                  //TODO: show device auth access error
                }
              );
              this.mobileService.showTouchIDAuth();
            }
            else {
              // alert("The device is not registered for Biometrics, please register using Settings options of the app");
            }
            //biometric authentication ends
          } else {
            this.mobileService.enableNFCSettings();
          }
        }).catch(e => console.error(e)); 
    }
  }

  nfcDefaultAppCheck(cardId){
    var that = this;
    entrust.checkDefaultNfcApp("",(result: any)=>{
      that.nfcPay(cardId);
    },(reason: any)=>{
      // that.nfcDefaultAppCheck(cardId);
    });
  }

  nfcPay(cardId) {
    var that = this;
        this.services.showSpinner();
    entrust.setNfcCard(cardId, sCallback, fCallback);
    function sCallback(arg) {
      console.log(arg);
      var cardArray = { "CardRefNO": that.containerData.cardRefNumber, "CardStatus": that.containerData.status, "CardNumber": that.containerData.cardNumber, "CardType": that.containerData.cardType, "digitalCardNum": arg.token };
     // clearInterval(this.downloadTimer);
     localStorage.setItem("tsp",arg.tspId);
      that.services.hideSpinner();
      that._nativeStorage.storeData('defaultCardId', cardId).then((value)=>{
        
      });
      that.startTransaction();
      that.router.navigate(['/home', 'tapnpaynfcinstruction'], { state: { cardData: cardArray } });
    //  this.router.navigate(['/home', 'tapnpaytxnsuccess'], { state: { cardData: cardArray } });
      // alert("setNfcCardArgument"+arg);
    }
    function fCallback(error) {
      console.log(error);
      that.services.hideSpinner();
      if (error == "Card_Suspended") {
        that.isRegisterVal = false;
        that.isCardStatusActVal = false;
        that.isCardStatusDeactVal = true;
     // $('.summary-card-footer').hide();
     that._debitService.setUpMenu();
      }
  
      else if (error == "Card_NotInWallet") {
        that.isRegisterVal = true;
        that.isCardStatusActVal = false;
        that.isCardStatusDeactVal = false;
        that._debitService.setUpMenu();
    //  $('.summary-card-footer').hide();
      }
    //  this.router.navigate(['/home', 'tapnpaytxnsuccess'], { state: { cardData: cardArray } });
      // alert("tapTpPayFailArgument"+arg);
    }
  }

  //successful transaction info
  // startTransaction() {
  //  var cardArray = { "CardRefNO": this.containerData.cardRefNumber, "CardStatus": this.containerData.status, "CardNumber": this.containerData.cardNumber, "CardType": this.containerData.cardType };
   /// this.router.navigate(['/home', 'tapnpaynfcinstruction'], { state: { cardData: cardArray } });
    // var txnStatus= "success";
    
    // if(txnStatus=="success") {
    //   this.mobileService.tapPay="Paid";
    //   clearInterval(this.mobileService.downloadTimer);
    //   this.router.navigate(['/home', 'tapnpaytxnsuccess'], { state: { cardData: cardArray } });
    // } else {

    // }
  
  // }

 startTransaction(){
  var that = this;
    entrust.startTransaction("",sCallback,fCallback);
    function sCallback(arg){
      // alert("Transaction Success");
            // console.log("startTransactionArguments"+arg);
            // alert("Transaction Amount"+arg.amount);
            // alert("Merchant"+arg.merchantName);
            // alert("Transaction Currency"+arg.currency);
            // alert("Transaction Date"+arg.date);
            // alert("Transaction Card"+arg.cardNumber);
            that.ngZone.run(() => {
            that.mobileService.tapPay="Paid";
            //var cardArray = { "CardRefNO": this.containerData.cardRefNumber, "CardStatus": this.containerData.status, "CardNumber": this.containerData.cardNumber, "CardType": this.containerData.cardType };            
              // var cardArray = {"txnDateTime":arg.date,"txnstatus":"SuccessEnd","cardNo":arg.cardNumber,"amount":arg.amount,"txnNo":arg.cardNumber,"currency":arg.currency};
            //  var cardArray = {"txnDateTime":"10Oct23","txnstatus":"SuccessEnd","cardNo":"1234","amount":"1234","txnNo":"1234","currency":"PGK"};

             clearInterval(that.mobileService.downloadTimer);
            // that.router.navigate(['/home', 'tapnpaytxnsuccess'], { state: { cardData: cardArray } });
            $('.main-header').show();
            $('.footer-dock-menu').show();
            that.router.navigate(['/home','cards']);
            });
            }
            function fCallback(arg){
            console.log(arg);
            // alert(arg);
            that.ngZone.run(() => {
              that.mobileService.tapPay="Paid";
              clearInterval(that.mobileService.downloadTimer);
              var cardArray = {"txnDateTime":"","txnstatus":"FailureEnd","cardNo":that.containerData.cardNumber,"amount":"","txnNo":that.containerData.cardNumber,"currency":""};
              that._commonService.hideSpinner();
              that.router.navigate(['/home', 'tapnpaytxnsuccess'], { state: { cardData: cardArray } });
             // that.router.navigate(["home", "cards"]);
            });
    }
    }

    nfcDefaultAppCheck1() {
      var that = this;
      entrust.checkDefaultNfcApp("",(result: any)=>{
        that.registerPay();
      },(reason: any)=>{
        // that.nfcDefaultAppCheck(cardId);
      });
    }


  registerPay() {
    //var tokenStatus=creditCards.TokenStatus;
    var cardArray = { "CardRefNO": this.containerData.cardRefNumber, "CardStatus": this.containerData.status, "CardNumber": this.containerData.cardNumber };
    let tokenStatus = "REGISTER";
    if (tokenStatus == "REGISTER") {
      //  this.router.navigate(['home','tapnpaytnc']);
      //  this.services.router.navigate(['/home/addProduct']);
      let dialogRef;
      let _data: IPopupScreenData = {
        screenData: {
          cardData: cardArray
        },
        screenTitle: "Terms and Conditions",
        component: 'TapnpayTncFormComponent'
      }
      dialogRef = this._dialog.open(PopupComponent, {
        width: '100%',
        data: _data,
        panelClass: 'popup-screen'
      });
    }
    else {//To Do}� 
    }

  }

  enableTooltip() {
    if (this.displayTooltip == true) {
      this.displayTooltip = false;
    }
    else {
      this.displayTooltip = true;
    }
  }

  

}
